export default __webpack_public_path__ + "static/Best-Countries-for-Shopaholics-Hong-Kong-dcdbe4a0ddd528fb29b626fe05da7215.jpg";